import { type Components } from '@mui/material';

import { HorizonTheme } from './horizon-theme';

export const muiDivider: Components<HorizonTheme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.gray100.main,
    }),
  },
};
